import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { enTranslations, znTranslations } from './utils';

/** 多语言初始化 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: Object.keys(enTranslations),
    defaultNS: 'common',
    lowerCaseLng: true,
    resources: {
      'zh-cn': znTranslations,
      en: enTranslations,
    },
    fallbackLng: 'zh-cn',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
